/// <reference path="../../adpIntegration/sections/adpIntegration.commission.section.ts" />

module Meevo.Plugins.AdpRunIntegration {
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class RunCommissionSection extends Meevo.Plugins.AdpIntegration.CommissionSection {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            $translate: angular.translate.ITranslateService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            modalService: Meevo.Components.Modal.IModalService,
            busyService: Components.Busy.IBusyService,
            compensationSettingsEndPoint : string,
            sectionSecurityKey?: string
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                $translate,
                noun,
                identityService,
                modalService,
                busyService,
                compensationSettingsEndPoint,
                sectionSecurityKey);
        }
    }
}